<template>
    <div>
        <kendo-switch
            name="switch"
            v-model="templateArgs.toggle.value"
            :messages="{ checked: templateArgs.toggle.checkLabel, unchecked: templateArgs.toggle.uncheckLabel }"
            :enabled="!templateArgs.toggle.disabled"
            @change="v => templateArgs.toggle.checkHandller(v.checked, templateArgs)"
        >
        </kendo-switch>
    </div>
</template>

<script>

export default {
    name: 'GridToggleTemplate',
    components: {
        // ToggleButton
    },
    data() {
        return {
            templateArgs: {}
        };
    }
};
</script>

<style>
/* .k-switch-handle{
    background-color: #009688 !important;
} */
</style>
